<template lang="pug">
  span {{ cleanBody }}
</template>

<script>
import GetItem from '@/Core/mixins/getItem';
import extractTextFromHtml from '@/Text/utilities/extractTextFromHtml';

export default {
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    }
  },
	computed: {
		cleanBody() {
				if(this.data.type && this.data.type === "Text Contact") {
					return extractTextFromHtml(this.data[this.dataKey]);
				}
				return this.data[this.dataKey];
			},
		}
};
</script>
